import React, { useState, useEffect } from 'react';
import { User, Clock, Users, TrendingUp, LogOut, CheckCircle, Mail, Phone, IdCard, Shield, AlertTriangle, Calendar } from 'lucide-react';
import LoginAdmin from './LoginAdmin';
import { getFechaColombia, getHoraColombia } from './colombiaTime';
import CalendarioAsistencia from './CalendarioAsistencia';

const API_URL = process.env.REACT_APP_API_URL || 'https://asistencia-backend.emarodri834.workers.dev/api';

export default function PanelAdmin() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [seccion, setSeccion] = useState('dashboard');
  const [marcajes, setMarcajes] = useState([]);
  const [pendientes, setPendientes] = useState([]);
  const [stats, setStats] = useState({});
  const [filtroFecha, setFiltroFecha] = useState('hoy');
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [marcajeManual, setMarcajeManual] = useState({
    empleado_nombre: '',
    tipo: 'entrada',
    fecha: getFechaColombia(),
    hora: getHoraColombia(),
    motivo: ''
  });
  const [empleadosActivos, setEmpleadosActivos] = useState([]);
  const [estadisticasEmpleado, setEstadisticasEmpleado] = useState(null);
  const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState('');
  const [periodoEstadisticas, setPeriodoEstadisticas] = useState('mes');

  // Estados para descansos
  const [descansoForm, setDescansoForm] = useState({
    empleado_id: '',
    descanso1_fecha: '',
    descanso1_notas: '',
    descanso2_fecha: '',
    descanso2_notas: ''
  });
  const [descansosListado, setDescansosListado] = useState([]);
  const [descansosEnCola, setDescansosEnCola] = useState([]); // NUEVO: Lista temporal antes de enviar
  const [filtroDescansos, setFiltroDescansos] = useState('todos'); // 'todos', 'pendientes', 'trabajados', 'solicitudes'
  const [solicitudesCambio, setSolicitudesCambio] = useState([]);
  
  // Estados para seguridad
  const [seccionSeguridad, setSeccionSeguridad] = useState('dispositivos');
  const [empleadoSeleccionadoSeguridad, setEmpleadoSeleccionadoSeguridad] = useState('');
  const [dispositivosEmpleado, setDispositivosEmpleado] = useState([]);
  const [intentosBloqueados, setIntentosBloqueados] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [errorMarcaje, setErrorMarcaje] = useState(null);

  useEffect(() => {
    if (isAuthenticated) {
      cargarDatos();
    }
  }, [isAuthenticated, filtroFecha]);

  const cargarDatos = async () => {
    try {
      const statsRes = await fetch(`${API_URL}/admin/estadisticas`);
      const statsData = await statsRes.json();
      setStats(statsData);

      const marcajesRes = await fetch(`${API_URL}/admin/marcajes`);
      const marcajesData = await marcajesRes.json();
    
      // Filtrar eliminados SOLO para la vista de Marcajes (NO afecta Calendario)
      const marcajesActivos = marcajesData.filter(m => m.eliminado !== 1);
      setMarcajes(marcajesActivos);

      const pendRes = await fetch(`${API_URL}/admin/empleados/pendientes`);
      const pendData = await pendRes.json();
      setPendientes(pendData);
    
      // Cargar empleados con ID (necesario para descansos y otras funcionalidades)
      const empleadosRes = await fetch(`${API_URL}/admin/empleados/todos?estado=ACTIVO`);
      const empleadosData = await empleadosRes.json();

      setEmpleadosActivos(empleadosData || []);
    } catch (error) {
      console.error('Error cargando datos:', error);
    }
  };
  const aprobarEmpleado = async (empleado) => {
    try {
      const response = await fetch(`${API_URL}/admin/empleados/aprobar/${empleado.id}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
      if (response.ok) {
        alert('Empleado aprobado');
        cargarDatos();
      }
    } catch (error) {
      console.error('Error aprobando empleado:', error);
    }
  };

  const rechazarEmpleado = async (id) => {
    try {
      const response = await fetch(`${API_URL}/admin/empleados/rechazar/${id}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
      if (response.ok) {
        alert('Empleado rechazado');
        cargarDatos();
      }
    } catch (error) {
      console.error('Error rechazando empleado:', error);
    }
  };

  const enviarMarcajeManual = () => {
    if (!marcajeManual.empleado_nombre || !marcajeManual.fecha || !marcajeManual.hora) {
      alert('Por favor completa todos los campos obligatorios');
      return;
    }
    setErrorMarcaje(null);
    setShowConfirmModal(true);
  };

  const confirmarMarcajeManual = async () => {
    setShowConfirmModal(false);

    try {
      const response = await fetch(`${API_URL}/admin/marcaje-manual`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(marcajeManual)
      });

      const data = await response.json();

      if (response.ok) {
        alert(`✅ ${data.mensaje}`);
        setMarcajeManual({
          empleado_nombre: '',
          tipo: 'entrada',
          fecha: new Date().toISOString().split('T')[0],
          hora: new Date().toTimeString().slice(0, 5),
          motivo: ''
        });
        setErrorMarcaje(null);
        cargarDatos();
      } else {
        setErrorMarcaje({ mensaje: data.error, tipo: data.tipo });
      }
    } catch (error) {
      setErrorMarcaje({ mensaje: 'Error de conexión', tipo: 'conexion' });
    }
  };

  // Funciones para descansos
  const cargarDescansos = async () => {
    try {
      const response = await fetch(`${API_URL}/admin/descansos`);
      const data = await response.json();
      
      if (data.success) {
        setDescansosListado(data.descansos);
      }
    } catch (error) {
      console.error('Error cargando descansos:', error);
    }
  };

  const cargarSolicitudesCambio = async () => {
    try {
      const response = await fetch(`${API_URL}/admin/solicitudes-cambio`);
      const data = await response.json();
      
      if (data.success) {
        setSolicitudesCambio(data.solicitudes);
      }
    } catch (error) {
      console.error('Error cargando solicitudes:', error);
    }
  };
  
  const aprobarSolicitudCambio = async (solicitudId) => {
    if (!window.confirm('¿Aprobar esta solicitud de cambio?')) {
      return;
    }
  
    try {
      const response = await fetch(`${API_URL}/admin/solicitudes-cambio/${solicitudId}/aprobar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
  
      const data = await response.json();
  
      if (response.ok) {
        alert('✅ ' + data.mensaje);
        await cargarSolicitudesCambio();
        await cargarDescansos();
      } else {
        alert('❌ ' + data.error);
      }
    } catch (error) {
      console.error('Error aprobando solicitud:', error);
      alert('Error de conexión');
    }
  };
  
  const rechazarSolicitudCambio = async (solicitudId) => {
    const motivo = window.prompt('¿Por qué rechazas esta solicitud?');
    
    if (!motivo || !motivo.trim()) {
      return;
    }
  
    try {
      const response = await fetch(`${API_URL}/admin/solicitudes-cambio/${solicitudId}/rechazar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ motivo_rechazo: motivo })
      });
  
      const data = await response.json();
  
      if (response.ok) {
        alert('✅ ' + data.mensaje);
        await cargarSolicitudesCambio();
      } else {
        alert('❌ ' + data.error);
      }
    } catch (error) {
      console.error('Error rechazando solicitud:', error);
      alert('Error de conexión');
    }
  };
  
  
  const eliminarDescanso = async (descansoId) => {
    if (!window.confirm('¿Estás seguro de eliminar este descanso programado?')) {
      return;
    }
  
    try {
      const response = await fetch(`${API_URL}/admin/descansos/${descansoId}`, {
        method: 'DELETE'
      });
  
      const data = await response.json();
  
      if (response.ok) {
        alert('✅ Descanso eliminado');
        cargarDescansos();
      } else {
        alert(`❌ ${data.error}`);
      }
    } catch (error) {
      console.error('Error eliminando descanso:', error);
      alert('Error de conexión');
    }
  };

  useEffect(() => {
    if (seccion === 'descansos') {
      cargarDescansos();
      cargarSolicitudesCambio();
    }
  }, [seccion]);
   
  const agregarALaCola = () => {
    if (!descansoForm.empleado_id) {
      alert('Debes seleccionar un empleado');
      return;
    }

    if (!descansoForm.descanso1_fecha && !descansoForm.descanso2_fecha) {
      alert('Debes ingresar al menos una fecha de descanso');
      return;
    }

    const empleadoSeleccionado = empleadosActivos.find(
      emp => emp.nombre === descansoForm.empleado_id
    );

    const nuevoItem = {
      id: Date.now(), // ID temporal para la lista
      empleado_id: empleadoSeleccionado.id,
      empleado_nombre: empleadoSeleccionado.nombre,
      descansos: []
    };

    if (descansoForm.descanso1_fecha) {
      nuevoItem.descansos.push({
        fecha: descansoForm.descanso1_fecha,
        notas: descansoForm.descanso1_notas
      });
    }


    if (descansoForm.descanso2_fecha) {
      nuevoItem.descansos.push({
        fecha: descansoForm.descanso2_fecha,
        notas: descansoForm.descanso2_notas
      });
    }

    setDescansosEnCola([...descansosEnCola, nuevoItem]);
  
    // Limpiar formulario
    setDescansoForm({
      empleado_id: '',
      descanso1_fecha: '',
      descanso1_notas: '',
      descanso2_fecha: '',
      descanso2_notas: ''
    });
  };

  const eliminarDeCola = (id) => {
    setDescansosEnCola(descansosEnCola.filter(item => item.id !== id));
  };
  
  const limpiarCola = () => {
    if (window.confirm('¿Estás seguro de limpiar toda la lista?')) {
      setDescansosEnCola([]);
    }
  };
  
  const programarTodosLosDescansos = async () => {
    if (descansosEnCola.length === 0) {
      alert('No hay descansos en la cola');
      return;
    }
  
    let exitosos = 0;
    let fallidos = 0;
    const errores = [];
  
    for (const item of descansosEnCola) {
      for (const descanso of item.descansos) {
        try {
          const response = await fetch(`${API_URL}/admin/descansos/programar`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              empleado_id: item.empleado_id,
              fecha: descanso.fecha,
              notas: descanso.notas
            })
          });
  
          if (response.ok) {
            exitosos++;
          } else {
            const error = await response.json();
            fallidos++;
            errores.push(`${item.empleado_nombre} (${descanso.fecha}): ${error.error}`);
          }
        } catch (error) {
          fallidos++;
          errores.push(`${item.empleado_nombre} (${descanso.fecha}): Error de conexión`);
        }
      }
    }
  
    let mensaje = `✅ ${exitosos} descanso(s) programado(s)`;
    if (fallidos > 0) {
      mensaje += `\n❌ ${fallidos} fallido(s):\n${errores.join('\n')}`;
    }
  
    alert(mensaje);
    
    setDescansosEnCola([]);
    await cargarDescansos();
  };
  
  
  const cargarEstadisticasEmpleado = async (nombre, periodo = 'mes') => {
    try {
      let fechaInicio, fechaFin;
      const hoy = new Date();
      
      if (periodo === 'semana') {
        fechaFin = hoy.toISOString().split('T')[0];
        const hace7dias = new Date(hoy);
        hace7dias.setDate(hoy.getDate() - 7);
        fechaInicio = hace7dias.toISOString().split('T')[0];
      } else if (periodo === 'mes') {
        fechaFin = hoy.toISOString().split('T')[0];
        const hace30dias = new Date(hoy);
        hace30dias.setDate(hoy.getDate() - 30);
        fechaInicio = hace30dias.toISOString().split('T')[0];
      }

      const response = await fetch(
        `${API_URL}/admin/estadisticas-empleado/${encodeURIComponent(nombre)}?fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}`
      );
      const data = await response.json();
      setEstadisticasEmpleado(data);
    } catch (error) {
      console.error('Error cargando estadísticas:', error);
    }
  };

  // Funciones de seguridad
  const cargarDispositivosEmpleado = async (nombre) => {
    try {
      const response = await fetch(`${API_URL}/admin/dispositivos/${encodeURIComponent(nombre)}`);
      const data = await response.json();
      setDispositivosEmpleado(data);
    } catch (error) {
      console.error('Error cargando dispositivos:', error);
    }
  };

  const cargarIntentosBloqueados = async () => {
    try {
      const response = await fetch(`${API_URL}/admin/intentos-bloqueados`);
      const data = await response.json();
      setIntentosBloqueados(data);
    } catch (error) {
      console.error('Error cargando intentos bloqueados:', error);
    }
  };

  useEffect(() => {
    if (seccion === 'seguridad' && seccionSeguridad === 'intentos') {
      cargarIntentosBloqueados();
    }
  }, [seccion, seccionSeguridad]);

  const formatearFecha = (fecha) => {
    return new Date(fecha + 'T00:00:00').toLocaleDateString('es-CO', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const formatearHora = (hora) => {
    if (!hora) return '-';
    const [h, m] = hora.split(':');
    const hour = parseInt(h);
    const hour12 = hour % 12 || 12;
    const ampm = hour >= 12 ? 'PM' : 'AM';
    return `${hour12}:${m} ${ampm}`;
  };

  const formatearHoras = (horas) => {
    const h = Math.floor(horas);
    const minutos = Math.round((horas - h) * 60);
    return `${h}h ${minutos}m`;
  };

  const getMarcajesPorFiltro = () => {
    // Obtener fecha de Colombia correctamente
    const now = new Date();
    const colombiaDate = new Date(now.toLocaleString('en-US', { timeZone: 'America/Bogota' }));
    const año = colombiaDate.getFullYear();
    const mes = String(colombiaDate.getMonth() + 1).padStart(2, '0');
    const dia = String(colombiaDate.getDate()).padStart(2, '0');
    const hoy = `${año}-${mes}-${dia}`;
  
    console.log('📅 Filtrando por fecha (Colombia):', hoy);

    const hace7dias = new Date(colombiaDate);
    hace7dias.setDate(hace7dias.getDate() - 7);
    const fechaHace7dias = `${hace7dias.getFullYear()}-${String(hace7dias.getMonth() + 1).padStart(2, '0')}-${String(hace7dias.getDate()).padStart(2, '0')}`;

    if (filtroFecha === 'hoy') {
      return marcajes.filter(m => m.fecha === hoy);
    } else if (filtroFecha === 'semana') {
      return marcajes.filter(m => m.fecha >= fechaHace7dias && m.fecha <= hoy);
    } else if (filtroFecha === 'personalizado' && fechaInicio && fechaFin) {
      return marcajes.filter(m => m.fecha >= fechaInicio && m.fecha <= fechaFin);
    }
    return marcajes;
  };

  if (!isAuthenticated) {
    return <LoginAdmin onLoginSuccess={() => setIsAuthenticated(true)} />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 text-white">
      <div className="flex">
        {/* Sidebar */}
        <div className="w-64 min-h-screen bg-black/30 backdrop-blur-lg border-r border-white/10 p-6">
          <div className="mb-8">
            <h1 className="text-2xl font-bold mb-1">Panel Admin</h1>
            <p className="text-sm opacity-60">Enruanados Gourmet</p>
          </div>

          <nav className="space-y-2">
            <button
              onClick={() => setSeccion('dashboard')}
              className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg transition-colors ${
                seccion === 'dashboard' 
                  ? 'bg-gradient-to-r from-blue-500 to-cyan-500 text-white' 
                  : 'hover:bg-white/10'
              }`}
            >
              <TrendingUp className="w-5 h-5" />
              <span className="font-semibold">Dashboard</span>
            </button>

            <button
              onClick={() => setSeccion('marcajes')}
              className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg transition-colors ${
                seccion === 'marcajes' 
                  ? 'bg-gradient-to-r from-green-500 to-emerald-500 text-white' 
                  : 'hover:bg-white/10'
              }`}
            >
              <Clock className="w-5 h-5" />
              <span className="font-semibold">Marcajes</span>
            </button>
            <button
              onClick={() => setSeccion('marcaje-manual')}
              className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg transition-colors ${
                seccion === 'marcaje-manual' 
                  ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white' 
                  : 'hover:bg-white/10'
              }`}
            >
              <User className="w-5 h-5" />
              <span className="font-semibold">Marcaje Manual</span>
            </button>
            <button
              onClick={() => setSeccion('descansos')}
              className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg transition-colors ${
                seccion === 'descansos' 
                  ? 'bg-gradient-to-r from-yellow-500 to-orange-500 text-white' 
                  : 'hover:bg-white/10'
              }`}
            >
              <Calendar className="w-5 h-5" />
              <span className="font-semibold">Programar Descansos</span>
            </button>
            <button
              onClick={() => setSeccion('estadisticas')}
              className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg transition-colors ${
                seccion === 'estadisticas' 
                  ? 'bg-gradient-to-r from-indigo-500 to-blue-500 text-white' 
                  : 'hover:bg-white/10'
              }`}
            >
              <Users className="w-5 h-5" />
              <span className="font-semibold">Estadísticas</span>
            </button>
            <button
              onClick={() => setSeccion('calendario')}
              className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg transition-colors ${
                seccion === 'calendario' 
                ? 'bg-gradient-to-r from-cyan-500 to-blue-500 text-white' 
                : 'hover:bg-white/10'
              }`}
            >
              <Calendar className="w-5 h-5" />
              <span className="font-semibold">Calendario</span>
            </button>
            <button
              onClick={() => setSeccion('seguridad')}
              className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg transition-colors ${
                seccion === 'seguridad' 
                  ? 'bg-gradient-to-r from-red-500 to-orange-500 text-white' 
                  : 'hover:bg-white/10'
              }`}
            >
              <Shield className="w-5 h-5" />
              <span className="font-semibold">Seguridad</span>
            </button>
          </nav>

          <button
            onClick={() => setIsAuthenticated(false)}
            className="flex items-center gap-3 w-full px-4 py-3 mt-8 rounded-lg bg-red-500/20 hover:bg-red-500/30 transition-colors"
          >
            <LogOut className="w-5 h-5" />
            <span className="font-semibold">Cerrar Sesión</span>
          </button>
        </div>

        {/* Contenido Principal */}
        <div className="flex-1 p-8">
          {/* Dashboard */}
          {seccion === 'dashboard' && (
            <div className="space-y-6">
              <h2 className="text-3xl font-bold mb-6">📊 Dashboard</h2>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div className="bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl p-6">
                  <Users className="w-8 h-8 mb-3 opacity-80" />
                  <div className="text-4xl font-bold mb-1">{stats.total_empleados || 0}</div>
                  <div className="text-sm opacity-80">Total Empleados</div>
                </div>

                <div className="bg-gradient-to-br from-green-500 to-emerald-500 rounded-xl p-6">
                  <CheckCircle className="w-8 h-8 mb-3 opacity-80" />
                  <div className="text-4xl font-bold mb-1">{stats.presentes_hoy || 0}</div>
                  <div className="text-sm opacity-80">Presentes Hoy</div>
                </div>

                <div className="bg-gradient-to-br from-orange-500 to-red-500 rounded-xl p-6">
                  <Users className="w-8 h-8 mb-3 opacity-80" />
                  <div className="text-4xl font-bold mb-1">{stats.ausentes_hoy || 0}</div>
                  <div className="text-sm opacity-80">Ausentes Hoy</div>
                </div>

                <div className="bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl p-6">
                  <Clock className="w-8 h-8 mb-3 opacity-80" />
                  <div className="text-4xl font-bold mb-1">{stats.marcajes_hoy || 0}</div>
                  <div className="text-sm opacity-80">Marcajes Hoy</div>
                </div>
              </div>
            </div>
          )}

          {/* Marcajes */}
          {seccion === 'marcajes' && (
            <div className="space-y-6">
              <div className="flex justify-between items-center">
                <h2 className="text-3xl font-bold">⏰ Marcajes</h2>
                 <div className="flex gap-2 items-center">
                   <button
                     onClick={() => setFiltroFecha('hoy')}
                     className={`px-4 py-2 rounded-lg font-semibold transition-all ${
                      filtroFecha === 'hoy' 
                        ? 'bg-blue-500 text-white shadow-lg scale-105' 
                        : 'bg-white/10 text-white/70 hover:bg-white/20'
                    }`}
                  >
                    Hoy
                  </button>
                  <button
                    onClick={() => setFiltroFecha('semana')}
                    className={`px-4 py-2 rounded-lg font-semibold transition-all ${
                      filtroFecha === 'semana' 
                        ? 'bg-blue-500 text-white shadow-lg scale-105' 
                        : 'bg-white/10 text-white/70 hover:bg-white/20'
                    }`}
                  >
                    Semana
                  </button>
                  <button
                    onClick={() => setFiltroFecha('personalizado')}
                    className={`px-4 py-2 rounded-lg font-semibold transition-all ${
                      filtroFecha === 'personalizado' 
                        ? 'bg-blue-500 text-white shadow-lg scale-105' 
                        : 'bg-white/10 text-white/70 hover:bg-white/20'
                    }`}
                  >
                    Personalizado
                  </button>
  
                  {filtroFecha === 'personalizado' && (
                    <div className="flex gap-2 ml-4">
                      <input
                        type="date"
                        value={fechaInicio}
                        onChange={(e) => setFechaInicio(e.target.value)}
                        className="px-3 py-2 rounded-lg bg-white/10 text-white border border-white/20"
                      />
                      <span className="text-white self-center">a</span>
                      <input
                        type="date"
                        value={fechaFin}
                        onChange={(e) => setFechaFin(e.target.value)}
                        className="px-3 py-2 rounded-lg bg-white/10 text-white border border-white/20"
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className="bg-white/5 rounded-xl border border-white/10 overflow-hidden">
                <table className="w-full">
                  <thead className="bg-white/10">
                    <tr>
                      <th className="text-left py-3 px-4">Empleado</th>
                      <th className="text-left py-3 px-4">Tipo</th>
                      <th className="text-left py-3 px-4">Fecha</th>
                      <th className="text-left py-3 px-4">Hora</th>
                      <th className="text-left py-3 px-4">Distancia</th>
                      <th className="text-left py-3 px-4">Dispositivo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getMarcajesPorFiltro().map((marcaje, idx) => (
                      <tr key={idx} className="border-b border-white/10 hover:bg-white/5">
                        <td className="py-3 px-4 font-semibold">{marcaje.empleado_nombre}</td>
                        <td className="py-3 px-4">
                          <span className={`px-3 py-1 rounded-full text-sm ${
                            marcaje.tipo === 'entrada' 
                              ? 'bg-green-500/20 text-green-400' 
                              : 'bg-blue-500/20 text-blue-400'
                          }`}>
                            {marcaje.tipo}
                          </span>
                        </td>
                        <td className="py-3 px-4">{marcaje.fecha}</td>
                        <td className="py-3 px-4 font-mono">{marcaje.hora}</td>
                        <td className="py-3 px-4">{marcaje.distancia_metros}m</td>
                        <td className="py-3 px-4">
                          <code className="text-xs bg-purple-500/20 px-2 py-1 rounded">
                            {marcaje.dispositivo?.substring(0, 20) || 'N/A'}
                          </code>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Aprobaciones */}
          {seccion === 'aprobaciones' && (
            <div className="space-y-6">
              <h2 className="text-3xl font-bold">✅ Empleados Pendientes</h2>

              {pendientes.length === 0 ? (
                <div className="bg-green-500/10 border border-green-500/50 rounded-xl p-8 text-center">
                  <CheckCircle className="w-16 h-16 mx-auto mb-4 text-green-400" />
                  <p className="text-xl">No hay empleados pendientes de aprobación</p>
                </div>
              ) : (
                <div className="grid gap-4">
                  {pendientes.map((empleado) => (
                    <div key={empleado.id} className="bg-white/5 rounded-xl border border-white/10 p-6">
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <h3 className="text-xl font-bold mb-2">{empleado.nombre}</h3>
                          <div className="grid grid-cols-2 gap-3 text-sm">
                            <div className="flex items-center gap-2">
                              <IdCard className="w-4 h-4 opacity-60" />
                              <span>Cédula: {empleado.cedula}</span>
                            </div>
                            <div className="flex items-center gap-2">
                              <Mail className="w-4 h-4 opacity-60" />
                              <span>{empleado.email || 'N/A'}</span>
                            </div>
                            <div className="flex items-center gap-2">
                              <Phone className="w-4 h-4 opacity-60" />
                              <span>{empleado.telefono || 'N/A'}</span>
                            </div>
                            <div className="flex items-center gap-2">
                              <User className="w-4 h-4 opacity-60" />
                              <span>Rol: {empleado.rol}</span>
                            </div>
                          </div>
                          {empleado.rol === 'mesero' && empleado.usuario_fudo && (
                            <div className="mt-4 bg-blue-500/10 border border-blue-500/50 rounded-lg p-3">
                              <div className="text-sm font-semibold text-blue-400 mb-2">🔑 Credenciales FUDO:</div>
                              <div className="space-y-1 text-sm">
                                <div>Usuario: <code className="bg-black/30 px-2 py-1 rounded">{empleado.usuario_fudo}</code></div>
                                <div>Contraseña: <code className="bg-black/30 px-2 py-1 rounded">{empleado.password_fudo}</code></div>
                              </div>
                              <div className="mt-2 text-xs text-yellow-400">
                                ⚠️ Crear esta cuenta en FUDO antes de aprobar
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="flex gap-2 ml-4">
                          <button
                            onClick={() => aprobarEmpleado(empleado)}
                            className="bg-green-500 hover:bg-green-600 px-6 py-2 rounded-lg font-semibold transition-colors"
                          >
                            ✓ Aprobar
                          </button>
                          <button
                            onClick={() => rechazarEmpleado(empleado.id)}
                            className="bg-red-500 hover:bg-red-600 px-6 py-2 rounded-lg font-semibold transition-colors"
                          >
                            ✗ Rechazar
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Marcaje Manual */}
          {seccion === 'marcaje-manual' && (
            <div className="space-y-6">
              <h2 className="text-3xl font-bold mb-6">✍️ Marcaje Manual</h2>

              <div className="bg-white/5 rounded-xl border border-white/10 p-6 max-w-2xl">
                <div className="space-y-4">
                  <div>
                    <label className="block mb-2 text-sm opacity-80">Empleado</label>
                    <select
                      value={marcajeManual.empleado_nombre}
                      onChange={(e) => setMarcajeManual({ ...marcajeManual, empleado_nombre: e.target.value })}
                      className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white [&>option]:bg-slate-900 [&>option]:text-white"
                    >
                      <option value="" className="bg-slate-900 text-white">
                        -- Selecciona un empleado --
                      </option>
                      {empleadosActivos.map((emp) => (
                        <option key={emp.id} value={emp.nombre} className="bg-slate-900 text-white">
                          {emp.nombre}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block mb-2 text-sm opacity-80">Tipo</label>
                      <select
                        value={marcajeManual.tipo}
                        onChange={(e) => setMarcajeManual({ ...marcajeManual, tipo: e.target.value })}
                        className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3"
                      >
                        <option value="entrada">Entrada</option>
                        <option value="salida">Salida</option>
                      </select>
                    </div>
                    <div>
                      <label className="block mb-2 text-sm opacity-80">Fecha</label>
                      <input
                        type="date"
                        value={marcajeManual.fecha}
                        onChange={(e) => setMarcajeManual({ ...marcajeManual, fecha: e.target.value })}
                        className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block mb-2 text-sm opacity-80">Hora</label>
                    <input
                      type="time"
                      value={marcajeManual.hora}
                      onChange={(e) => setMarcajeManual({ ...marcajeManual, hora: e.target.value })}
                      className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3"
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm opacity-80">Motivo (opcional)</label>
                    <textarea
                      value={marcajeManual.motivo}
                      onChange={(e) => setMarcajeManual({ ...marcajeManual, motivo: e.target.value })}
                      className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 h-24"
                      placeholder="Ej: Olvidó marcar, Error en el sistema, etc."
                    />
                  </div>

                  <button
                    onClick={enviarMarcajeManual}
                    className="w-full bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 py-3 rounded-lg font-semibold transition-colors"
                  >
                    📝 Registrar Marcaje
                    {errorMarcaje && (
                      <div className={`p-4 rounded-lg border ${
                        errorMarcaje.tipo === 'entrada_duplicada' || errorMarcaje.tipo === 'sin_entrada_previa'
                          ? 'bg-yellow-500/10 border-yellow-500'
                          : 'bg-red-500/10 border-red-500'
                      }`}>
                        <p className="font-semibold mb-2">
                          {errorMarcaje.tipo === 'entrada_duplicada' && '⚠️ Entrada Duplicada'}
                          {errorMarcaje.tipo === 'sin_entrada_previa' && '⚠️ Sin Entrada Previa'}
                          {errorMarcaje.tipo === 'hora_invalida' && '❌ Hora Inválida'}
                          {!errorMarcaje.tipo && '❌ Error'}
                        </p>
                        <p className="text-sm">{errorMarcaje.mensaje}</p>
                      </div>
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Estadísticas */}
          {seccion === 'estadisticas' && (
            <div className="space-y-6">
              <h2 className="text-3xl font-bold mb-6">📊 Estadísticas por Empleado</h2>

              <div className="bg-white/5 rounded-xl border border-white/10 p-6 max-w-2xl">
                <div className="space-y-4">
                  <div>
                    <label className="block mb-2 text-sm opacity-80">Selecciona empleado</label>
                    <select
                      value={empleadoSeleccionado}
                      onChange={(e) => {
                        setEmpleadoSeleccionado(e.target.value);
                        if (e.target.value) {
                          cargarEstadisticasEmpleado(e.target.value, periodoEstadisticas);
                        }
                      }}
                      className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white [&>option]:bg-slate-900 [&>option]:text-white"
                    >
                      <option value="" className="bg-slate-900 text-white">
                        -- Selecciona un empleado --
                      </option>
                      {empleadosActivos.map((emp) => (
                        <option key={emp.id} value={emp.nombre} className="bg-slate-900 text-white">
                          {emp.nombre}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block mb-2 text-sm opacity-80">Período</label>
                    <div className="flex gap-2">
                      <button
                        onClick={() => {
                          setPeriodoEstadisticas('semana');
                          if (empleadoSeleccionado) cargarEstadisticasEmpleado(empleadoSeleccionado, 'semana');
                        }}
                        className={`flex-1 py-2 rounded-lg ${
                          periodoEstadisticas === 'semana' ? 'bg-blue-500' : 'bg-white/10'
                        }`}
                      >
                        Última Semana
                      </button>
                      <button
                        onClick={() => {
                          setPeriodoEstadisticas('mes');
                          if (empleadoSeleccionado) cargarEstadisticasEmpleado(empleadoSeleccionado, 'mes');
                        }}
                        className={`flex-1 py-2 rounded-lg ${
                          periodoEstadisticas === 'mes' ? 'bg-blue-500' : 'bg-white/10'
                        }`}
                      >
                        Último Mes
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {estadisticasEmpleado && (
                <div className="space-y-6">
                  {/* Resumen de estadísticas */}
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    <div className="bg-gradient-to-br from-blue-500 to-blue-700 rounded-xl p-6 text-white">
                      <div className="text-sm opacity-80 mb-1">Días Trabajados</div>
                      <div className="text-4xl font-bold">{estadisticasEmpleado.resumen.dias_trabajados}</div>
                    </div>
                    <div className="bg-gradient-to-br from-green-500 to-green-700 rounded-xl p-6 text-white">
                      <div className="text-sm opacity-80 mb-1">Turnos Completos</div>
                      <div className="text-4xl font-bold">{estadisticasEmpleado.resumen.turnos_completos}</div>
                      <div className="text-xs opacity-70 mt-1">&gt; 7 horas</div>
                    </div>
                    <div className="bg-gradient-to-br from-purple-500 to-purple-700 rounded-xl p-6 text-white">
                      <div className="text-sm opacity-80 mb-1">Total Horas</div>
                      <div className="text-4xl font-bold">{formatearHoras(estadisticasEmpleado.resumen.total_horas || 0)}</div>
                    </div>
                    <div className="bg-gradient-to-br from-orange-500 to-orange-700 rounded-xl p-6 text-white">
                      <div className="text-sm opacity-80 mb-1">Total Marcajes</div>
                      <div className="text-4xl font-bold">{estadisticasEmpleado.resumen.total_marcajes}</div>
                      <div className="text-xs opacity-70 mt-1">
                        {estadisticasEmpleado.resumen.entradas} entradas / {estadisticasEmpleado.resumen.salidas} salidas
                      </div>
                    </div>
                  </div>

                  {/* Detalle por días */}
                  <div className="bg-white/5 rounded-xl border border-white/10 overflow-hidden">
                    <div className="bg-white/10 px-6 py-4">
                      <h3 className="text-xl font-bold">Detalle por Día</h3>
                    </div>
                    <table className="w-full">
                      <thead className="bg-white/5">
                        <tr>
                          <th className="text-left py-3 px-4">Fecha</th>
                          <th className="text-left py-3 px-4">Primera Entrada</th>
                          <th className="text-left py-3 px-4">Última Salida</th>
                          <th className="text-left py-3 px-4">Horas Trabajadas</th>
                          <th className="text-left py-3 px-4">Tipo Turno</th>
                          <th className="text-left py-3 px-4">Extras</th>
                        </tr>
                      </thead>
                      <tbody>
                        {estadisticasEmpleado.detalle_dias
                          .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
                          .map((dia, idx) => (
                          <tr key={idx} className="border-b border-white/10 hover:bg-white/5">
                            <td className="py-3 px-4">{formatearFecha(dia.fecha)}</td>
                            <td className="py-3 px-4 font-mono">
                              {dia.entrada ? formatearHora(dia.entrada) : '-'}
                            </td>
                            <td className="py-3 px-4 font-mono">
                              {dia.salida ? formatearHora(dia.salida) : '-'}
                            </td>
                            <td className="py-3 px-4 font-bold">
                              {formatearHoras(dia.horas_trabajadas || 0)}
                            </td>
                            <td className="py-3 px-4">
                              <span className={`px-3 py-1 rounded-full text-sm ${
                                dia.tipo_turno === 'completo'
                                  ? 'bg-green-500/20 text-green-400'
                                  : 'bg-orange-500/20 text-orange-400'
                              }`}>
                                {dia.tipo_turno}
                              </span>
                            </td>
                            <td className="py-3 px-4">
                              {dia.extras && (
                                <span className="px-3 py-1 rounded-full text-sm bg-blue-500/20 text-blue-400">
                                  ⭐ Sí
                                </span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Seguridad */}
          {seccion === 'seguridad' && (
            <div className="space-y-6">
              <div>
                <h2 className="text-3xl font-bold mb-2">🛡️ Panel de Seguridad</h2>
                <p className="opacity-80">Control de dispositivos y alertas</p>
              </div>

              {/* Tabs */}
              <div className="flex gap-2 border-b border-white/10">
                <button
                  onClick={() => setSeccionSeguridad('dispositivos')}
                  className={`px-4 py-2 font-semibold transition-colors ${
                    seccionSeguridad === 'dispositivos'
                      ? 'border-b-2 border-blue-500 text-blue-400'
                      : 'opacity-60 hover:opacity-100'
                  }`}
                >
                  📱 Dispositivos
                </button>
                <button
                  onClick={() => setSeccionSeguridad('intentos')}
                  className={`px-4 py-2 font-semibold transition-colors ${
                    seccionSeguridad === 'intentos'
                      ? 'border-b-2 border-red-500 text-red-400'
                      : 'opacity-60 hover:opacity-100'
                  }`}
                >
                  ⚠️ Intentos Bloqueados
                </button>
              </div>

              {/* Dispositivos */}
              {seccionSeguridad === 'dispositivos' && (
                <div>
                  <div className="mb-4">
                    <label className="block mb-2 opacity-80">Selecciona empleado:</label>
                    <select
                      value={empleadoSeleccionadoSeguridad}
                      onChange={(e) => {
                        setEmpleadoSeleccionadoSeguridad(e.target.value);
                        if (e.target.value) cargarDispositivosEmpleado(e.target.value);
                      }}
                      className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white [&>option]:bg-slate-900 [&>option]:text-white"
                    >
                      <option value="" className="bg-slate-900 text-white">
                        -- Selecciona un empleado --
                      </option>
                      {empleadosActivos.map((emp) => (
                        <option key={emp.id} value={emp.nombre} className="bg-slate-900 text-white">
                          {emp.nombre}
                        </option>
                      ))}
                    </select>
                  </div>

                  {dispositivosEmpleado.length > 0 ? (
                    <div className="bg-white/5 rounded-xl border border-white/10 overflow-hidden">
                      <table className="w-full">
                        <thead className="bg-white/10">
                          <tr>
                            <th className="text-left py-3 px-4">Device ID</th>
                            <th className="text-left py-3 px-4">User Agent</th>
                            <th className="text-left py-3 px-4">IP</th>
                            <th className="text-left py-3 px-4">Último Uso</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dispositivosEmpleado.map((disp, idx) => (
                            <tr key={idx} className="border-b border-white/10 hover:bg-white/5">
                              <td className="py-3 px-4">
                                <code className="text-xs bg-blue-500/20 px-2 py-1 rounded">
                                  {disp.device_id.substring(0, 24)}...
                                </code>
                              </td>
                              <td className="py-3 px-4 text-sm opacity-80 max-w-xs truncate">
                                {disp.user_agent || 'N/A'}
                              </td>
                              <td className="py-3 px-4">{disp.primera_ip}</td>
                              <td className="py-3 px-4">{disp.fecha_ultimo_uso}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : empleadoSeleccionadoSeguridad ? (
                    <div className="bg-yellow-500/10 border border-yellow-500/50 rounded-xl p-6 text-center">
                      <AlertTriangle className="w-12 h-12 mx-auto mb-3 text-yellow-400" />
                      <p>No hay dispositivos registrados para este empleado</p>
                    </div>
                  ) : null}
                </div>
              )}

              {/* Intentos Bloqueados */}
              {seccionSeguridad === 'intentos' && (
                <div>
                  <div className="mb-4 flex justify-between items-center">
                    <h3 className="text-xl font-bold">Intentos Bloqueados Recientes</h3>
                    <button
                      onClick={cargarIntentosBloqueados}
                      className="bg-blue-500 hover:bg-blue-600 px-4 py-2 rounded-lg transition-colors"
                    >
                      🔄 Actualizar
                    </button>
                  </div>

                  {intentosBloqueados.length > 0 ? (
                    <div className="bg-white/5 rounded-xl border border-white/10 overflow-hidden">
                      <table className="w-full">
                        <thead className="bg-white/10">
                          <tr>
                            <th className="text-left py-3 px-4">Fecha/Hora</th>
                            <th className="text-left py-3 px-4">Empleado</th>
                            <th className="text-left py-3 px-4">Motivo</th>
                            <th className="text-left py-3 px-4">IP</th>
                            <th className="text-left py-3 px-4">Device ID</th>
                          </tr>
                        </thead>
                        <tbody>
                          {intentosBloqueados.map((intento, idx) => (
                            <tr key={idx} className="border-b border-white/10 hover:bg-white/5">
                              <td className="py-3 px-4">
                                <div className="text-sm">{intento.fecha}</div>
                                <div className="text-xs opacity-60">{intento.hora}</div>
                              </td>
                              <td className="py-3 px-4 font-semibold">
                                {intento.empleado_nombre}
                              </td>
                              <td className="py-3 px-4">
                                <span className="bg-red-500/20 text-red-400 px-3 py-1 rounded-full text-sm">
                                  {intento.motivo}
                                </span>
                              </td>
                              <td className="py-3 px-4 text-sm opacity-80">
                                {intento.ip}
                              </td>
                              <td className="py-3 px-4">
                                <code className="text-xs bg-gray-500/20 px-2 py-1 rounded">
                                  {intento.device_id?.substring(0, 16)}...
                                </code>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="bg-green-500/10 border border-green-500/50 rounded-xl p-8 text-center">
                      <CheckCircle className="w-16 h-16 mx-auto mb-4 text-green-400" />
                      <p className="text-xl font-semibold text-green-400">✅ No hay intentos bloqueados recientes</p>
                      <p className="text-sm opacity-60 mt-2">El sistema de seguridad está funcionando correctamente</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          {/* Calendario de Asistencia */}
          {seccion === 'calendario' && (
            <CalendarioAsistencia />
          )}
          {/* Modal de Confirmación */}
          {showConfirmModal && (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
              <div className="bg-slate-800 rounded-xl p-6 max-w-md w-full mx-4 border border-white/20">
                <h3 className="text-xl font-bold mb-4">⚠️ Confirmar Marcaje Manual</h3>
      
                <div className="space-y-2 mb-6 text-sm">
                  <div className="flex justify-between">
                    <span className="opacity-70">Empleado:</span>
                    <span className="font-semibold">{marcajeManual.empleado_nombre}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="opacity-70">Tipo:</span>
                    <span className={`font-semibold ${
                      marcajeManual.tipo === 'entrada' ? 'text-green-400' : 'text-blue-400'
                    }`}>
                      {marcajeManual.tipo.toUpperCase()}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="opacity-70">Fecha:</span>
                    <span className="font-mono">{marcajeManual.fecha}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="opacity-70">Hora:</span>
                    <span className="font-mono">{marcajeManual.hora}</span>
                  </div>
                  {marcajeManual.motivo && (
                    <div className="pt-2 border-t border-white/10">
                      <span className="opacity-70">Motivo:</span>
                      <p className="mt-1">{marcajeManual.motivo}</p>
                    </div>
                  )}
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={confirmarMarcajeManual}
                    className="flex-1 bg-green-600 hover:bg-green-700 py-2 rounded-lg font-semibold"
                  >
                    ✓ Confirmar
                  </button>
                  <button
                    onClick={() => setShowConfirmModal(false)}
                    className="flex-1 bg-red-600 hover:bg-red-700 py-2 rounded-lg font-semibold"
                  >
                    ✗ Cancelar
                  </button>
                </div>
              </div>
            </div>
          )}
          {/* Programar Descansos */}
          {seccion === 'descansos' && (
          <div className="space-y-6">
            <div>
              <h2 className="text-3xl font-bold mb-2">📅 Programar Descansos</h2>
              <p className="opacity-80">Máximo 2 descansos por quincena por empleado</p>
            </div>
        
            {/* Formulario */}
            <div className="bg-white/5 rounded-xl border border-white/10 p-6 max-w-2xl">
              <h3 className="text-xl font-bold mb-4">➕ Agregar Descansos para Empleado</h3>
              
              <div className="space-y-4">
                <div>
                  <label className="block mb-2 text-sm opacity-80">Empleado</label>
                  <select
                    value={descansoForm.empleado_id}
                    onChange={(e) => setDescansoForm({ ...descansoForm, empleado_id: e.target.value })}
                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white [&>option]:bg-slate-900 [&>option]:text-white"
                  >
                    <option value="" className="bg-slate-900 text-white">
                      -- Selecciona un empleado --
                    </option>
                    {empleadosActivos.map((emp) => (
                      <option key={emp.id} value={emp.nombre} className="bg-slate-900 text-white">
                        {emp.nombre}
                      </option>
                    ))}
                  </select>
                </div>
        
                {/* Descanso 1 */}
                <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4">
                  <h4 className="font-semibold mb-3 text-blue-300">📅 Descanso 1</h4>
                  <div className="space-y-3">
                    <div>
                      <label className="block mb-2 text-sm opacity-80">Fecha</label>
                      <input
                        type="date"
                        value={descansoForm.descanso1_fecha}
                        onChange={(e) => setDescansoForm({ ...descansoForm, descanso1_fecha: e.target.value })}
                        className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white"
                      />
                    </div>
                    <div>
                      <label className="block mb-2 text-sm opacity-80">Notas (opcional)</label>
                      <input
                        type="text"
                        value={descansoForm.descanso1_notas}
                        onChange={(e) => setDescansoForm({ ...descansoForm, descanso1_notas: e.target.value })}
                        className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white"
                        placeholder="Ej: Día personal, vacaciones..."
                      />
                    </div>
                  </div>
                </div>
        
                {/* Descanso 2 */}
                <div className="bg-purple-500/10 border border-purple-500/30 rounded-lg p-4">
                  <h4 className="font-semibold mb-3 text-purple-300">📅 Descanso 2</h4>
                  <div className="space-y-3">
                    <div>
                      <label className="block mb-2 text-sm opacity-80">Fecha</label>
                      <input
                        type="date"
                        value={descansoForm.descanso2_fecha}
                        onChange={(e) => setDescansoForm({ ...descansoForm, descanso2_fecha: e.target.value })}
                        className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white"
                      />
                    </div>
                    <div>
                      <label className="block mb-2 text-sm opacity-80">Notas (opcional)</label>
                      <input
                        type="text"
                        value={descansoForm.descanso2_notas}
                        onChange={(e) => setDescansoForm({ ...descansoForm, descanso2_notas: e.target.value })}
                        className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white"
                        placeholder="Ej: Día personal, vacaciones..."
                      />
                    </div>
                  </div>
                </div>
        
                <button
                  onClick={agregarALaCola}
                  className="w-full bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 py-3 rounded-lg font-semibold transition-colors"
                >
                  ➕ Agregar a la Lista
                </button>
              </div>
            </div>
        
            {/* Lista de descansos en cola */}
            {descansosEnCola.length > 0 && (
              <div className="bg-white/5 rounded-xl border border-white/10 p-6">
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-xl font-bold">📋 Descansos por Programar ({descansosEnCola.length})</h3>
                  <button
                    onClick={limpiarCola}
                    className="text-red-400 hover:text-red-300 text-sm"
                  >
                    🗑️ Limpiar Todo
                  </button>
                </div>
                
                <div className="space-y-3">
                  {descansosEnCola.map((item) => (
                    <div key={item.id} className="bg-white/5 rounded-lg p-4 flex justify-between items-start">
                      <div className="flex-1">
                        <div className="font-semibold text-lg mb-2">{item.empleado_nombre}</div>
                        <div className="space-y-1 text-sm">
                          {item.descansos.map((d, idx) => (
                            <div key={idx} className="flex gap-2">
                              <span className="opacity-60">📅 Descanso {idx + 1}:</span>
                              <span className="font-mono">{d.fecha}</span>
                              {d.notas && <span className="opacity-60">- {d.notas}</span>}
                            </div>
                          ))}
                        </div>
                      </div>
                      <button
                        onClick={() => eliminarDeCola(item.id)}
                        className="text-red-400 hover:text-red-300 ml-4"
                      >
                        ❌
                      </button>
                    </div>
                  ))}
                </div>
        
                <div className="flex gap-3 mt-4">
                  <button
                    onClick={programarTodosLosDescansos}
                    className="flex-1 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 py-3 rounded-lg font-semibold transition-colors"
                  >
                    ✅ Programar Todos los Descansos
                  </button>
                </div>
              </div>
            )}
        
            {/* Filtros */}
            <div className="flex gap-2">
              <button
                onClick={() => setFiltroDescansos('todos')}
                className={`px-4 py-2 rounded-lg font-semibold transition-all ${
                  filtroDescansos === 'todos' 
                    ? 'bg-blue-500 text-white' 
                    : 'bg-white/10 hover:bg-white/20'
                }`}
              >
                Todos
              </button>
              <button
                onClick={() => setFiltroDescansos('pendientes')}
                className={`px-4 py-2 rounded-lg font-semibold transition-all ${
                  filtroDescansos === 'pendientes' 
                    ? 'bg-yellow-500 text-white' 
                    : 'bg-white/10 hover:bg-white/20'
                }`}
              >
                Pendientes
              </button>
              <button
                onClick={() => setFiltroDescansos('trabajados')}
                className={`px-4 py-2 rounded-lg font-semibold transition-all ${
                  filtroDescansos === 'trabajados' 
                    ? 'bg-green-500 text-white' 
                    : 'bg-white/10 hover:bg-white/20'
                }`}
              >
                Trabajados (Extras)
              </button>
              <button
                onClick={() => setFiltroDescansos('solicitudes')}
                className={`px-4 py-2 rounded-lg font-semibold transition-all ${
                  filtroDescansos === 'solicitudes' 
                    ? 'bg-orange-500 text-white' 
                    : 'bg-white/10 hover:bg-white/20'
                }`}
              >
                🔄 Solicitudes de Cambio
              </button>
            </div>
        
            {/* Listado de Descansos */}
            <div className="bg-white/5 rounded-xl border border-white/10 overflow-hidden">
              <div className="bg-white/10 px-6 py-4">
                <h3 className="text-xl font-bold">
                  {filtroDescansos === 'solicitudes' ? '🔄 Solicitudes de Cambio' : 'Descansos Programados'}
                </h3>
              </div>
              {filtroDescansos === 'solicitudes' ? (
                // Vista de Solicitudes de Cambio
                solicitudesCambio.length === 0 ? (
                  <div className="p-8 text-center opacity-60">
                    No hay solicitudes de cambio pendientes
                  </div>
                ) : (
                  <table className="w-full">
                    <thead className="bg-white/5">
                      <tr>
                        <th className="text-left py-3 px-4">Empleado</th>
                        <th className="text-left py-3 px-4">Fecha Actual</th>
                        <th className="text-left py-3 px-4">Fecha Nueva</th>
                        <th className="text-left py-3 px-4">Motivo</th>
                        <th className="text-left py-3 px-4">Solicitado</th>
                        <th className="text-left py-3 px-4">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {solicitudesCambio.map((solicitud, idx) => (
                        <tr key={idx} className="border-b border-white/10 hover:bg-white/5">
                          <td className="py-3 px-4 font-semibold">{solicitud.empleado_nombre}</td>
                          <td className="py-3 px-4">
                            <span className="px-2 py-1 bg-red-500/20 text-red-300 rounded text-sm">
                              {solicitud.fecha_actual}
                            </span>
                          </td>
                          <td className="py-3 px-4">
                            <span className="px-2 py-1 bg-green-500/20 text-green-300 rounded text-sm">
                              {solicitud.fecha_nueva}
                            </span>
                          </td>
                          <td className="py-3 px-4 text-sm opacity-80 max-w-xs">
                            {solicitud.motivo}
                          </td>
                          <td className="py-3 px-4 text-xs opacity-60">
                            {new Date(solicitud.created_at).toLocaleDateString('es-CO', {
                              day: '2-digit',
                              month: 'short',
                              hour: '2-digit',
                              minute: '2-digit'
                            })}
                          </td>
                          <td className="py-3 px-4">
                            <div className="flex gap-2">
                              <button
                                onClick={() => aprobarSolicitudCambio(solicitud.id)}
                                className="bg-green-500/20 hover:bg-green-500/30 text-green-400 px-3 py-1 rounded text-sm transition-colors"
                              >
                                ✓ Aprobar
                              </button>
                              <button
                                onClick={() => rechazarSolicitudCambio(solicitud.id)}
                                className="bg-red-500/20 hover:bg-red-500/30 text-red-400 px-3 py-1 rounded text-sm transition-colors"
                              >
                                ✗ Rechazar
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )
              ) : (
                // Vista normal de descansos programados
                descansosListado.length === 0 ? (
                  <div className="p-8 text-center opacity-60">
                    No hay descansos programados
                  </div>
                ) : (
                  <table className="w-full">
                    <thead className="bg-white/5">
                      <tr>
                        <th className="text-left py-3 px-4">Empleado</th>
                        <th className="text-left py-3 px-4">Fecha</th>
                        <th className="text-left py-3 px-4">Periodo</th>
                        <th className="text-left py-3 px-4">Estado</th>
                        <th className="text-left py-3 px-4">Notas</th>
                        <th className="text-left py-3 px-4">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {descansosListado
                        .filter(d => {
                          if (filtroDescansos === 'pendientes') return d.trabajado === 0;
                          if (filtroDescansos === 'trabajados') return d.trabajado === 1;
                          return true;
                        })
                        .map((descanso, idx) => (
                          <tr key={idx} className="border-b border-white/10 hover:bg-white/5">
                            <td className="py-3 px-4 font-semibold">{descanso.empleado_nombre}</td>
                            <td className="py-3 px-4">{descanso.fecha}</td>
                            <td className="py-3 px-4 text-sm opacity-80">
                              {descanso.periodo_inicio} / {descanso.periodo_fin}
                            </td>
                            <td className="py-3 px-4">
                              {descanso.trabajado === 2 ? (
                                <span className="px-3 py-1 rounded-full text-sm bg-blue-500/20 text-blue-400">
                                  ✅ Descansado
                                </span>
                              ) : descanso.trabajado === 1 ? (
                                <span className="px-3 py-1 rounded-full text-sm bg-green-500/20 text-green-400">
                                  ⭐ Trabajado (Extra)
                                </span>
                              ) : (
                                <span className="px-3 py-1 rounded-full text-sm bg-yellow-500/20 text-yellow-400">
                                  📅 Programado
                                </span>
                              )}
                            </td>
                            <td className="py-3 px-4 text-sm opacity-70">
                              {descanso.notas || '-'}
                            </td>
                            <td className="py-3 px-4">
                              {descanso.trabajado === 0 && (
                                <button
                                  onClick={() => eliminarDescanso(descanso.id)}
                                  className="bg-red-500/20 hover:bg-red-500/30 text-red-400 px-3 py-1 rounded text-sm transition-colors"
                                >
                                  Eliminar
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                )
              )}
            </div>
          </div>
        )}
        </div>
      </div>
    </div>
  );
}
